export interface NotifyOptions {
  type: "success" | "info" | "warning" | "error";
  duration: number;
  title: string;
  text: string;
  error?: any;
}

export interface NotifyContainer {
  push(options: NotifyOptions): void;
}

let notifyContainer: NotifyContainer;

export function notifyInit(container: NotifyContainer): void {
  notifyContainer = container;
}

export function notify(options: NotifyOptions): void {
  notifyContainer?.push(options);
}

export const NOTIFICATION_STICKY = -1;

export function notifySuccess(
  title: string,
  text: string,
  duration: number = 2000
): void {
  notifyContainer?.push({
    type: "success",
    title,
    text,
    duration
  });
}

export function notifyWarning(
  title: string,
  text: string,
  duration: number = 2000
): void {
  notifyContainer?.push({
    type: "warning",
    title,
    text,
    duration
  });
}

export function notifyFailure(
  title: string,
  text: string,
  error: any = null,
  duration: number = 3000
): void {
  error && console.error(error);
  notifyContainer?.push({
    type: "error",
    title,
    text,
    error,
    duration
  });
}
